import React, { useMemo, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLayout } from "../../contexts/layoutContext";
import { BRAND, NAV_SECTIONS, LOGO_URL, isRouteActive } from "../../config/navigation";
import "./headers.css";

export const Headers = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isDesktop, sidebarCollapsed, sidebarExpanded } = useLayout();

  const handleNavigate = useCallback(
    (route) => () => navigate(route),
    [navigate]
  );

  const isActive = useCallback(
    (route) => isRouteActive(location.pathname, route),
    [location.pathname]
  );

  const showLabels = sidebarExpanded;

  const sidebarClassName = useMemo(
    () =>
      `app-sidebar fixed top-0 left-0 z-40 flex h-screen flex-col transition-[width] duration-200 ease-out ${
        sidebarCollapsed ? "w-16" : "w-60"
      }`,
    [sidebarCollapsed]
  );

  if (!isDesktop) return null;

  return (
    <aside className={sidebarClassName} aria-label="Menú principal">
      <div className="app-sidebar__brand flex shrink-0 items-center justify-center px-3 py-4">
        <img
          className={`app-sidebar__logo ${
            showLabels ? "app-sidebar__logo--expanded" : "app-sidebar__logo--collapsed"
          }`}
          src={LOGO_URL}
          alt={BRAND.logoAlt}
        />
      </div>

      {showLabels && (
        <div className="app-sidebar__brand-text">
          <p className="app-sidebar__brand-name">{BRAND.name}</p>
          <p className="app-sidebar__subtitle">{BRAND.panelLabel}</p>
        </div>
      )}

      <nav className="app-sidebar-nav flex-1 overflow-y-auto overflow-x-hidden px-2 py-2">
        {NAV_SECTIONS.map((section) => (
          <div key={section.id} className="app-sidebar__section">
            {showLabels && (
              <p className="app-sidebar__section-title">{section.title}</p>
            )}
            <ul className="app-sidebar__list">
              {section.items.map((item) => {
                const Icon = item.icon;
                const active = isActive(item.route);

                return (
                  <li key={item.route}>
                    <button
                      type="button"
                      onClick={handleNavigate(item.route)}
                      title={!showLabels ? item.label : item.description}
                      className={`app-sidebar-item w-full ${
                        active ? "app-sidebar-item--active" : ""
                      } ${showLabels ? "justify-start gap-3 px-3" : "justify-center px-0"}`}
                    >
                      <Icon size={22} className="shrink-0" aria-hidden />
                      {showLabels && (
                        <span className="app-sidebar-item__text">
                          <span className="app-sidebar-item__label">{item.label}</span>
                          {item.description && (
                            <span className="app-sidebar-item__hint">{item.description}</span>
                          )}
                        </span>
                      )}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </nav>
    </aside>
  );
};
